'use client';
import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

const LoginContext = createContext<{
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
}>({
  email: '',
  setEmail: () => '',
});

export const LoginProvider = ({ children }: PropsWithChildren) => {
  const [email, setEmail] = useState('');

  return (
    <LoginContext.Provider value={{ email, setEmail }}>
      {children}
    </LoginContext.Provider>
  );
};

export const useLogin = () => {
  return useContext(LoginContext);
};
